export default __webpack_public_path__ + "static/media/trackYourReadingDark.c1e78933.png";